/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { tagCandidateFileDataAttributeSchema } from './TagCandidateFileDataAttributeSchema'

export const tagCandidateFileDataSchema = z.object({
	attribute: tagCandidateFileDataAttributeSchema,
})

export type TagCandidateFileDataSchema = z.infer<typeof tagCandidateFileDataSchema>
